var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#606060;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.19,21.31c-3,0-6.1,0-9.16,0a.71.71,0,0,0-.76.51A7.64,7.64,0,0,1,24,26.58a7.67,7.67,0,0,1-7.31-4.77c-.18-.39-.35-.53-.77-.51-.81,0-1.62,0-2.43,0a2.72,2.72,0,0,1-2.8-2.65A2.69,2.69,0,0,1,13.48,16c.85,0,1.71,0,2.56,0a.51.51,0,0,0,.55-.35,7.61,7.61,0,0,1,7.38-5,7.59,7.59,0,0,1,7.36,5c.16.37.41.33.69.33H50.59a2.67,2.67,0,0,1,2.62,2.5A2.64,2.64,0,0,1,51,21.25a4.42,4.42,0,0,1-.81.06ZM21.31,18.66A2.65,2.65,0,1,0,23.92,16,2.66,2.66,0,0,0,21.31,18.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.64,42.56h9.22a.66.66,0,0,0,.73-.46,7.68,7.68,0,0,1,7.34-4.82,7.64,7.64,0,0,1,7.3,4.8.69.69,0,0,0,.78.48c.79,0,1.58,0,2.37,0a2.67,2.67,0,1,1,0,5.32c-.83,0-1.66,0-2.49,0a.54.54,0,0,0-.6.37,7.64,7.64,0,0,1-7.39,4.93,7.61,7.61,0,0,1-7.33-4.93c-.18-.4-.43-.36-.73-.36H13.52a2.67,2.67,0,1,1,0-5.32C16.54,42.55,19.59,42.56,22.64,42.56Zm19.92,2.7a2.65,2.65,0,1,0-2.66,2.63A2.65,2.65,0,0,0,42.56,45.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconFilter);
export default __webpack_public_path__ + "static/media/app_icon_filter.28ff1b6345a65975c6f7b2e4e5025f81.svg";
export { ForwardRef as ReactComponent };